import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { setUserData } from "../redux/actions/UserActions";
import { getItem } from "../services/localStorageService";
import { authUser } from "../constants/auth";
import jwt_decode from "jwt-decode";

class Auth extends Component {
  constructor(props) {
    super(props);
    const userData = getItem(authUser);
    if (userData?.idToken) {
      try {
        const { exp } = jwt_decode(userData.idToken);
        if (Date.now() >= exp * 1000) {
          localStorage.clear();
          return;
        }
      } catch {
        localStorage.clear();
        return;
      }
    }
    this.props.setUserData(userData);
    this.props.setUserData(getItem("userInfo"));
  }

  render() {
    const { children } = this.props;
    return <>{children}</>;
  }
}

export default connect(null, { setUserData })(Auth);
